import { TicketRepository } from '../repositories/TicketRepository'

export function ListAreasCase(ticketRepository: TicketRepository) {
  return async function () {
    return await ticketRepository.listAreas()
  }
}
